module.exports = __webpack_public_path__ + "fontawesome-webfont-25e755c96612d7e3de0e3776b8386214.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome/fonts/fontawesome-webfont.eot
// module id = 75
// module chunks = 0 1